import useHttpProvider from "@/common/hooks/use-http";
import { useEffect, useState } from "react";
import { Partner } from "../models/partner";
import * as PartnersServices from "../services/partners";

function usePartners() {
	const { http } = useHttpProvider();

	const [partners, setPartners] = useState<Partner[]>([]);
	const [selectedPartner, setSelectedPartner] = useState<Partner | undefined>();
	const [showPartnerDiscountsModal, setShowPartnerDiscountsModal] =
		useState(false);

	async function getPartners() {
		const partners = await PartnersServices.getPartners(http);
		setPartners(partners);
	}

	function onPartnerClicked(partner: Partner) {
		setSelectedPartner(partner);
		setShowPartnerDiscountsModal(true);
	}

	useEffect(() => {
		getPartners();
	}, []);

	return {
		partners,
		selectedPartner,
		onPartnerClicked,
		showPartnerDiscountsModal,
		setShowPartnerDiscountsModal,
	};
}

export default usePartners;
